var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM3.2,11c-1.4-0.3-2.4-1.7-2.4-3.1c0-1.6,1.3-3,2.8-3.1c0,0,0-0.1,0-0.1c-0.1-2,1.5-3.6,3.5-3.6c0,0,0,0,0.1,0\n\t\tc2.5,0,3.4,1.9,3.4,1.9l0,0c0.2,0,0.4-0.1,0.6-0.1c2.2,0,4,1.9,4,4.1c0,2-1.5,3.6-3.4,3.9","key":0}),React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t7.2,14.9 9.2,11 5.2,11 \t","key":1}),React.createElement("line",{"fill":"transparent","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.2","y1":"5.6","x2":"7.2","y2":"10.8","key":2})]));
}

Download.displayName = "Download";

Download.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Download;

Download.default = Download;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/download.svg
// module id = ../icon/src/icons/download.svg
// module chunks = 0